import React from 'react';

import { useLocation } from 'react-router-dom';

import { ChipColor, ChipMember } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import { Wrapper, YatLink } from './styles';

export const YatStatic = () => {
    const eid = useAppSelector((state) => state.yatPage.eid);
    const location = useLocation();

    if (!eid) return null;

    return (
        <Wrapper>
            <YatLink to={`/${eid}/yats${location.search}`}>
                <ChipMember yat={eid || undefined} color={ChipColor.Transparent} size={'large'} />
            </YatLink>
        </Wrapper>
    );
};
